<div class="chep-activity-content">
  <p-card header="CHEP Activity Summary">
    <p-table [autoLayout]="true">
        <ng-template pTemplate="header">
        <tr>
            <th>Customer</th>
            <th>BOL #</th>
            <th>Trailer #</th>
            <th>SCAC</th>
            <th>Pallet Type</th>
            <th>Qty</th>
            <th >Auth #</th>
        </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
        <tr>
            <!-- <td>{{ row.customer }}</td>
            <td>{{ row.bolNumber }}</td>
            <td>{{ row.trailerNumber }}</td>
            <td>{{ row.scac }}</td>
            <td>{{ row.product }}</td>
            <td>{{ row.quantity }}</td>
            <td>{{ row.authorizationNumber }}</td> -->
        </tr>
        </ng-template>
    </p-table>
  </p-card>
</div>
